const CommonError = {
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const RateError = {
  "ttl": true,
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const OtpError = {
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const AccessError = {
  "authRedirect": true,
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const FormError = {
  "fieldName": true,
  "fieldLabel": true,
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const ExternalServiceError = {
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const ProtocolError = {
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const InternalError = {
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const UserError = {
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const BasketRuleBenefitDiscount = {
  "UID": true,
  "TYPE": {},
  "DISCOUNT_PERCENT": true
}
const BasketRuleBenefitGift = {
  "UID": true,
  "TYPE": {},
  "PRODUCT_ID": true
}
const VorderError = {
  "itemUuid": true,
  "fieldName": true,
  "fieldLabel": true,
  "section": {},
  "type": {},
  "name": {},
  "message": true,
  "messages": true,
  "alertShow": true,
  "alertMessage": true,
  "alertDuration": true,
  "targetShow": true,
  "targetMessage": true,
  "debug": true,
  "rel": true,
  "data": true
}
const TestItem = {
  "id": true,
  "name": true,
  "description": true,
  "createdAt": true
}
const EntityOption = {
  "UID": true,
  "ID": true,
  "NAME": true,
  "CODE": true,
  "TAXONOMY_TERM_ID": true,
  "TAXONOMY_TERM_IDS": true,
  "PARENT_ID": true,
  "ACTIVE": true
}
const EntityType = {
  "UID": true,
  "PROVIDER_TYPE": true,
  "PROVIDER_TYPE_NAME": true,
  "PROVIDER": true,
  "PROVIDER_NAME": true,
  "BUNDLE_CODE": true,
  "BUNDLE_ID": true,
  "ENTITY_TYPE": true,
  "TAXONOMY_TYPE": true,
  "TAXONOMY_MEMBER_TYPE": true,
  "NAME": true,
  "ROLE": true,
  "CLASS": true,
  "RIGHTS": true,
  "TAXONOMY_TERMS": {
    "__fragment": "EntityOption"
  },
  "OPTIONS": {
    "__fragment": "EntityOption"
  }
}
const EntityProviderType = {
  "CODE": true,
  "NAME": true
}
const EntityComputedField = {
  "entityType": true,
  "entityBundleCode": true,
  "entityBundleId": true,
  "name": true,
  "type": true,
  "conditionDate": true,
  "valueType": true,
  "round": true,
  "valueOptions": {
    "__fragment": "EntityComputedFieldValueOption"
  },
  "entityField": true
}
const EntityComputedFieldValueOption = {
  "label": true,
  "value": true
}
const Menu = {
  "id": true,
  "code": true,
  "children": {
    "__fragment": "MenuItem"
  }
}
const MenuItem = {
  "id": true,
  "parent": true,
  "label": true,
  "infoLabel": true,
  "command": {
    "__fragment": "Command"
  },
  "url": true,
  "blank": true,
  "native": true,
  "icon": true,
  "imageId": true,
  "image": {
    "__fragment": "Image"
  },
  "display": true,
  "color": true,
  "bgColor": true,
  "children": {
    "__fragment": "MenuItem"
  },
  "roles": true,
  "entityType": true,
  "entityId": true,
  "badge": true,
  "params": true,
  "size": true,
  "outline": true,
  "flat": true,
  "width": true,
  "class": true,
  "onClick": true,
  "dense": true,
  "loading": true,
  "loadingLabel": true,
  "disable": true,
  "textColor": true
}
const Command = {
  "code": true,
  "type": true,
  "path": true,
  "params": true,
  "confirm": true
}
const Image = {
  "ID": true,
  "SRC": true,
  "SRC_DEFAULT": true,
  "FILE_SIZE": true,
  "ORIGINAL_NAME": true
}
const ClientEmit = {
  "id": true,
  "title": true,
  "message": true,
  "body": true,
  "eventName": true,
  "eventData": true,
  "eventGroup": true,
  "targetUserId": true,
  "targetClientId": true,
  "createdAt": true,
  "cls": true
}
const ClientNotice = {
  "ID": true,
  "TITLE": true,
  "MESSAGE": true,
  "BODY": true,
  "EVENT_NAME": true,
  "EVENT_DATA": true,
  "EVENT_GROUP": true,
  "ENTITY_TYPE": true,
  "ENTITY_ID": true,
  "TARGET_CLIENT_ID": true,
  "TARGET_USER_ID": true,
  "CREATED_AT_FORMATTED": true,
  "CREATED_AT": true,
  "ACTION_MOBILE": true,
  "ACTIVE": true,
  "IMAGE": {
    "__fragment": "Image"
  },
  "TARGET": {},
  "BODY_HTML": true,
  "SHOW_AS": {},
  "image": {
    "__fragment": "Image"
  },
  "IMPORTANT": true,
  "haveBody": true,
  "showAs": true,
  "targetCode": true,
  "actionItems": {
    "__fragment": "MenuItem"
  },
  "cls": true,
  "isReaded": true
}
const UserSession = {
  "SESSION_ID": true,
  "USER_ID": true,
  "FUSER_ID": true
}
const User = {
  "ID": true,
  "NAME": true,
  "SESSION_ID": true,
  "GROUPS": {
    "__fragment": "UserGroup"
  },
  "ROLES": true,
  "DL": true,
  "LOGIN": true,
  "LOGIN_FORMAT": true,
  "EMAIL": true,
  "NAME_FULL": true,
  "NAME_TEASER": true,
  "LAST_NAME": true,
  "SECOND_NAME": true,
  "PHONE": true,
  "PHONE_FORMATTED": true,
  "PERSONAL_PHOTO": {
    "__fragment": "Image"
  },
  "PERSONAL_BIRTHDAY": true,
  "DATE_REGISTER": true,
  "LAST_LOGIN": true,
  "PERSON_TYPE_ID": true,
  "PROPS": {
    "__fragment": "EntityProp"
  },
  "PROMOCODE": true,
  "AVATAR": {
    "__fragment": "UserAvatar"
  },
  "GREETING_NAME": true,
  "FAMILY": {
    "__fragment": "UserFamily"
  },
  "PROFILE_FILLED": true,
  "PROFILE_GIFT_USED": true,
  "COMPUTED": true,
  "ORDER_COUNT": true,
  "SUBSCRIPTIONS": true
}
const UserGroup = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "DL": true
}
const EntityProp = {
  "ID": true,
  "CODE": true,
  "NAME": true,
  "TYPE": true,
  "VAL": true,
  "VAL_ID": true,
  "VAL_ENUM_ID": true,
  "DESC": true,
  "MUL": true,
  "FILE": {
    "__fragment": "Image"
  },
  "FILES": {
    "__fragment": "Image"
  }
}
const UserAvatar = {
  "ELEMENT_ID": true,
  "IMAGE": {
    "__fragment": "Image"
  }
}
const UserFamily = {
  "ID": true,
  "NAME": true,
  "RELATION": true,
  "USER_ID": true,
  "BIRTHDAY": true
}
const AppClient = {
  "ID": true,
  "CLIENT_ID": true,
  "TOKEN": true,
  "SESSION_ID": true,
  "CURRENT_SESSION_ID": true,
  "USER_ID": true,
  "WEB_PUSH_TOKEN": true,
  "MOBILE_PUSH_TOKEN": true,
  "WEB_PUSH_ENDPOINT": true,
  "WEB_PUSH_P256DH": true,
  "WEB_PUSH_AUTH": true,
  "WEB_PUSH_ACTIVE": true,
  "DEBUG_PARAMS": {
    "__fragment": "AppClientDebugParams"
  }
}
const AppClientDebugParams = {
  "eventsTransport": true
}
const Page = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "PageProps"
  },
  "DATA_CHUNKS": {
    "__fragment": "PageDataChunk"
  },
  "CONTENT_CHUNKS": {
    "__fragment": "PageContentChunk"
  }
}
const Section = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_TYPE_ID": true,
  "IBLOCK_EXTERNAL_ID": true,
  "EXTERNAL_ID": true,
  "IBLOCK_SECTION_ID": true,
  "TIMESTAMP_X": true,
  "ACTIVE": true,
  "PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DESCRIPTION": true,
  "DESCRIPTION_TYPE": true,
  "LEFT_MARGIN": true,
  "RIGHT_MARGIN": true,
  "DEPTH_LEVEL": true,
  "SEARCHABLE_CONTENT": true,
  "SECTION_PAGE_URL": true,
  "DATE_CREATE": true,
  "PARENT": {
    "__fragment": "Section"
  },
  "PARENTS": {
    "__fragment": "Section"
  },
  "ELEMENT_CNT": true,
  "META": {
    "__fragment": "ElementMeta"
  },
  "REPLACE_LINK": true,
  "CHILDREN": {
    "__fragment": "Section"
  }
}
const ElementMeta = {
  "TITLE": true,
  "KEYWORDS": true,
  "DESCRIPTION": true,
  "PAGE_TITLE": true
}
const PageProps = {
  "TPL_PAGE_VIEW": true,
  "TPL_PAGE_CONTENT": true,
  "DATA_CHUNKS": {
    "__fragment": "ElementPropValueWithDesc"
  },
  "CHUNKS": {
    "__fragment": "PagePropsChunks"
  },
  "CHUNK_NAME": true,
  "CHUNK_VALUE": {
    "__fragment": "ElementPropValueHtml"
  },
  "CHUNK_CODE": true,
  "CHUNK_GROUP": true,
  "META_TITLE": true,
  "META_DESCRIPTION": true,
  "META_KEYWORDS": true
}
const ElementPropValueWithDesc = {
  "VALUE": true,
  "DESC": true
}
const PagePropsChunks = {
  "CHUNK_CODE": true,
  "CHUNK_NAME": true,
  "CHUNK_VALUE": {
    "__fragment": "ElementPropValueHtml"
  },
  "CHUNK_GROUP": true,
  "UID": true
}
const ElementPropValueHtml = {
  "TEXT": true,
  "TYPE": true
}
const PageDataChunk = {
  "CODE": true,
  "TYPE": true,
  "VALUE": true
}
const PageContentChunk = {
  "GROUP": true,
  "NAME": true,
  "CODE": true,
  "VALUE": true,
  "TYPE": true
}
const PageRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "Page"
  }
}
const QueryInfo = {
  "total": true,
  "page": true,
  "pages": true,
  "limit": true,
  "nextPage": true
}
const CompanyOffice = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "CompanyOfficeProps"
  }
}
const CompanyOfficeProps = {
  "MAIN": true,
  "ADDRESS": true,
  "PHONES": true,
  "EMAIL": true,
  "COORDINATES": {
    "__fragment": "Coordinates"
  },
  "REQUISITES": {
    "__fragment": "ElementPropValueHtml"
  },
  "ROLES": {
    "__fragment": "ListValue"
  },
  "WORKTIME": true,
  "SERVICE_ID": true,
  "PAYSYSTEM_ID": true,
  "GIS_URL": true,
  "INFO_URL": true
}
const Coordinates = {
  "LON": true,
  "LAT": true
}
const ListValue = {
  "ID": true,
  "VALUE": true,
  "CODE": true
}
const OfficeRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "CompanyOffice"
  }
}
const CompanyVacancy = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "CompanyVacancyProps"
  }
}
const CompanyVacancyProps = {
  "PAYMENT": true,
  "RESPONSIBILITES": {
    "__fragment": "ElementPropValueHtml"
  },
  "WORK_EXPERIENCE": true
}
const VacancyRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "CompanyVacancy"
  }
}
const FaqQuestion = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  }
}
const FaqQuestionRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "FaqQuestion"
  }
}
const GeoObject = {
  "geo_lat": true,
  "geo_lon": true,
  "address_original": true,
  "address_full": true,
  "address_short": true,
  "street_path_full": true,
  "street_path_short": true,
  "region": true,
  "region_format": true,
  "region_original": true,
  "region_fias_id": true,
  "area": true,
  "area_format": true,
  "area_original": true,
  "area_fias_id": true,
  "city": true,
  "city_format": true,
  "city_original": true,
  "city_fias_id": true,
  "district": true,
  "district_format": true,
  "district_original": true,
  "district_fias_id": true,
  "street": true,
  "street_format": true,
  "street_original": true,
  "street_fias_id": true,
  "house": true,
  "house_format": true,
  "house_original": true,
  "house_fias_id": true
}
const SearchSuggestion = {
  "label": true,
  "value": true,
  "data": {
    "__fragment": "SearchSuggestionData"
  }
}
const SearchSuggestionData = {
  "type": true,
  "entityTypeName": true,
  "entityTypeCode": true,
  "entityTypeId": true,
  "entityRole": true,
  "entityId": true,
  "entityTitle": true,
  "hint": true
}
const Offer = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "VID": true,
  "OFFER_NAME": true,
  "STARTUP_SHOW": true,
  "BANNER_INTERNAL_TEXT": true,
  "BANNER_HOR_MOBILE": {
    "__fragment": "Image"
  },
  "BANNER_HOR_DESKTOP": {
    "__fragment": "Image"
  },
  "BANNER_SQUARE": {
    "__fragment": "Image"
  },
  "DISCOUNT_ID": true,
  "CONTENT_IMAGE": {
    "__fragment": "Image"
  },
  "SLIDES": {
    "__fragment": "OfferSlide"
  },
  "ACTIONS_WEB": {
    "__fragment": "MenuItem"
  },
  "ACTIONS_MOBILE": {
    "__fragment": "MenuItemMobile"
  },
  "IS_HOT": true,
  "VARS": true,
  "VIEW_MODE": true,
  "STICKY": true,
  "STICKY_TITLE": true,
  "STICKY_ICON": true,
  "FEATURES": true
}
const OfferSlide = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "CONTENT_TYPE": true,
  "CONTENT_IMAGE": {
    "__fragment": "Image"
  },
  "CONTENT_HTML": true,
  "BG_COLOR": true
}
const MenuItemMobile = {
  "id": true,
  "parent": true,
  "label": true,
  "icon": true,
  "imageId": true,
  "image": {
    "__fragment": "Image"
  },
  "color": true,
  "backgroundColor": true,
  "outlineColor": true,
  "outlineWidth": true,
  "link": true,
  "outline": true,
  "labelColor": true,
  "badge": true,
  "params": true,
  "action": {
    "__fragment": "ActionMobile"
  },
  "condition": {
    "__fragment": "Condition"
  },
  "templatable": true,
  "templatableProps": true,
  "roles": true
}
const ActionMobile = {
  "code": true,
  "url": true,
  "title": true,
  "titleAuto": true,
  "replace": true,
  "addBacklink": true,
  "addSession": true,
  "await": true
}
const Condition = {
  "path": true,
  "eq": true,
  "gt": true,
  "lt": true
}
const OfferRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "Offer"
  }
}
const PushSubscriber = {
  "ID": true
}
const FortunePrize = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "FortunePrizeProps"
  },
  "PRIZE_TYPE": {},
  "BACKGROUND_COLOR": true,
  "TEXT_COLOR": true,
  "TEXT_ORIENTATION": true,
  "PROBABILITY": true,
  "GIFT_ELEMENT": true,
  "DISCOUNT_ELEMENT": true
}
const FortunePrizeProps = {
  "BACKGROUND_COLOR": true,
  "TEXT_COLOR": true,
  "TEXT_ORIENTATION": {
    "__fragment": "ListValue"
  },
  "PROBABILITY": true,
  "PRIZE_TYPE": {},
  "GIFT_ELEMENT_ENTITY": {
    "__fragment": "Element"
  },
  "GIFT_ELEMENT": true,
  "DISCOUNT_ELEMENT_ENTITY": {
    "__fragment": "Element"
  },
  "DISCOUNT_ELEMENT": true
}
const Element = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  }
}
const FortuneUserPrize = {
  "ID": true,
  "USER_ID": true,
  "CREATED_AT": true,
  "PRIZE_ELEMENT_ID_ENTITY": {
    "__fragment": "Element"
  },
  "PRIZE_ELEMENT_ID": true,
  "IS_USED": true
}
const TelegramChat = {
  "ID": true,
  "CHAT_ID": true,
  "TELEGRAM_ID": true,
  "USER_ID": true,
  "PHONE": true,
  "STATUS": true,
  "CREATED_AT": true,
  "UPDATED_AT": true,
  "LAST_ACTIVITY": true,
  "UID": true,
  "CONTACT_PHONE": true
}
const TelegramChatRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "TelegramChat"
  }
}
const Webcam = {
  "ID": true,
  "NAME": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "WebcamProps"
  }
}
const WebcamProps = {
  "CODE": true
}
const Review = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "ReviewProps"
  },
  "ELEMENT": {
    "__fragment": "Element"
  },
  "CHILDREN": {
    "__fragment": "Review"
  },
  "ORDER": {
    "__fragment": "Order"
  }
}
const ReviewProps = {
  "AUTHOR_USER_ID": true,
  "AUTHOR_NAME": true,
  "RATING": true,
  "ELEMENT_ID_ENTITY": {
    "__fragment": "Element"
  },
  "ELEMENT_ID": true,
  "CONTEXT_ID": true,
  "ANSWER": true
}
const Order = {
  "ID": true,
  "TS": true,
  "SYNCED": true,
  "SERVICE_ID": true,
  "PERSON_TYPE_ID": true,
  "URL": true,
  "USER_ID": true,
  "USER": {
    "__fragment": "User"
  },
  "DATE_INSERT": true,
  "DATE_UPDATE": true,
  "DATE_PAYED": true,
  "DATE_FORMATTED": true,
  "DATE_TIME_FORMATTED": true,
  "PRICE": true,
  "PRICE_BASKET": true,
  "PRICE_BASKET_BASE": true,
  "PRICE_DISCOUNT": true,
  "PRICE_DELIVERY": true,
  "PRICE_DELIVERY_BASE": true,
  "PRICE_TOTAL": true,
  "PRICE_TOTAL_BASE": true,
  "PRICE_PAY": true,
  "PRICE_PAY_BASE": true,
  "DISCOUNT_PERCENT": true,
  "DISCOUNT_REASON": true,
  "DELIVERY_FREE_FROM_PRICE": true,
  "DELIVERY_ADDRESS_FULL": true,
  "DELIVERY_DATETIME": true,
  "DELIVERY_ID": true,
  "DELIVERY": {
    "__fragment": "DeliveryService"
  },
  "DELIVERY_CALCULATED": true,
  "DELIVERY_DEPARTMENT": {
    "__fragment": "CompanyOffice"
  },
  "PICKUP_DEPARTMENT": {
    "__fragment": "CompanyOffice"
  },
  "PAYSYSTEM_ID": true,
  "PAYSYSTEM": {
    "__fragment": "Paysystem"
  },
  "PAYSYSTEM_IS_ONLINE": true,
  "BASKET": {
    "__fragment": "BasketItem"
  },
  "STATUS": {
    "__fragment": "OrderStatus"
  },
  "STATUS_ID": true,
  "STATUS_NAME": true,
  "STATUS_COLOR": true,
  "CSTATUS_ID": true,
  "CSTATUS_NAME": true,
  "CSTATUS_COLOR": true,
  "IS_PAID": true,
  "IS_ACTIVE": true,
  "IS_FINISHED": true,
  "IS_CANCELED": true,
  "IS_CAN_PAY": true,
  "IS_CAN_PAY_ONLINE": true,
  "IS_CAN_PAY_BILL": true,
  "IS_CAN_CANCEL": true,
  "USER_DESCRIPTION": true,
  "ACCESS_HASH": true,
  "SECRET_URL": true,
  "ACCOUNT_NUMBER": true,
  "PAYMENTS": {
    "__fragment": "Payment"
  },
  "BUYER_NAME": true,
  "CONTRACT_NUM": true,
  "EDU_GROUP_NUM": true,
  "STUDENT_FIO": true,
  "PAY_LINK": true,
  "SCOPE": {
    "__fragment": "OrderScope"
  },
  "SCOPE_ENTITY": {
    "__fragment": "Command"
  },
  "ACTIONS": true,
  "COUPONS": {
    "__fragment": "Coupon"
  },
  "BONUSES": true,
  "COURIER_STATE": {
    "__fragment": "CourierState"
  },
  "ADDRESS_FOR_1C": true,
  "CANCEL_REASONS": {
    "__fragment": "OrderCancelReason"
  },
  "ATTR_VALUE": {
    "__fragment": "OrderAttributesValue"
  },
  "ATTR_VIEW": {
    "__fragment": "OrderAttributesView"
  },
  "ATTRS": {
    "__fragment": "OrderAttribute"
  }
}
const DeliveryService = {
  "ID": true,
  "NAME": true,
  "PARENT_ID": true,
  "TRANSPORT_TYPE": {}
}
const Paysystem = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "DESCRIPTION": true,
  "IS_INNER": true,
  "IS_ONLINE": true,
  "IS_ONLINE_DELAYED": true,
  "IS_BILL": true
}
const BasketItem = {
  "ID": true,
  "UUID": true,
  "PARENT_ID": true,
  "PARENT_UUID": true,
  "ORDER_ID": true,
  "PRODUCT_ID": true,
  "NAME": true,
  "DESC": true,
  "QUANTITY": true,
  "BASE_PRICE": true,
  "PRICE_BASE": true,
  "PRICE": true,
  "FINAL_PRICE": true,
  "FINAL_PRICE_BASE": true,
  "MEASURE_NAME": true,
  "COMMENT": true,
  "PAID": true,
  "INPUT_PROPS_HASH": true,
  "DISABLE": true,
  "DISABLE_REASON": true,
  "BENEFIT": {},
  "DISCOUNTS": {
    "__fragment": "BasketItemDiscount"
  },
  "CLIENT_CHANGED_AT": true,
  "ELEMENT": {
    "__fragment": "Product"
  },
  "BUILD": {
    "__fragment": "BasketBuildItem"
  },
  "MODIFICATORS": true,
  "PROPERTIES": {
    "__fragment": "BasketItemProps"
  }
}
const BasketItemDiscount = {
  "RULE": true,
  "TARGET": {},
  "TYPE": {},
  "AMOUNT": true,
  "DISCOUNTED_PRICE": true,
  "BASE_PRICE": true
}
const Product = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "ProductProps"
  },
  "PRICE": {
    "__fragment": "ProductPrice"
  },
  "MEASURE": {
    "__fragment": "ProductMeasure"
  },
  "PARENT": {
    "__fragment": "Product"
  },
  "OFFERS": {
    "__fragment": "Product"
  },
  "IS_SALE_SPECIAL": true,
  "SALES_COUNT": true,
  "HIT_POSITION": true,
  "HIT_SECTION_POSITION": true,
  "WEIGHT": true,
  "OFFER_PARENT_ELEMENT": {
    "__fragment": "Product"
  },
  "INGREDIENTS": {
    "__fragment": "Ingredient"
  },
  "FEATURE_IDS": true,
  "IMAGE": {
    "__fragment": "Image"
  }
}
const ProductProps = {
  "WEIGHT": true,
  "KKAL": true,
  "BELKI": true,
  "ZHIRY": true,
  "UGLEVODY": true,
  "ROLLS_ENTITIES": {
    "__fragment": "Element"
  },
  "ROLLS": true,
  "PHOTOV2": {
    "__fragment": "Image"
  },
  "COMPONENT_IS": {
    "__fragment": "ListValue"
  },
  "INGREDIENTS_ENTITIES": {
    "__fragment": "Element"
  },
  "INGREDIENTS": true,
  "SERVICE_ID": true,
  "SALE_SPECIAL": true,
  "FLAGS_ENTITIES": {
    "__fragment": "Element"
  },
  "FLAGS": true,
  "SET_ITEMS": {
    "__fragment": "ProductPropsSetItems"
  },
  "MODIFICATORS_ENTITIES": {
    "__fragment": "Element"
  },
  "MODIFICATORS": true,
  "FEATURES_ENTITIES": {
    "__fragment": "Element"
  },
  "FEATURES": true,
  "HIT_POSITION": true,
  "HIT_SECTION_POSITION": true
}
const ProductPropsSetItems = {
  "PRODUCT_ID_ENTITY": {
    "__fragment": "Element"
  },
  "PRODUCT_ID": true,
  "QUANTITY": true,
  "UID": true
}
const ProductPrice = {
  "PRICE": true,
  "DISCOUNTED": true,
  "DISCOUNT_PERCENT": true
}
const ProductMeasure = {
  "NAME": true,
  "RATIO": true
}
const Ingredient = {
  "ELEMENT_ID": true,
  "IS_REMOVABLE": true
}
const BasketBuildItem = {
  "PRODUCT_ID": true,
  "QUANTITY": true,
  "ELEMENT": {
    "__fragment": "Product"
  }
}
const BasketItemProps = {
  "CATALOG_XML_ID": true,
  "PRODUCT_XML_ID": true,
  "PARENT_UUID": true,
  "IS_GIFT": true,
  "REASON_MOD_CODE": true,
  "REASON_MOD_ID": true,
  "REASON_RULE_CODE": true,
  "REASON_RULE_ID": true,
  "INGREDIENTS_REMOVED": true,
  "INGREDIENTS_ADDED": true
}
const OrderStatus = {
  "ID": true,
  "NAME": true,
  "SORT": true,
  "COLOR": true,
  "TYPE": true
}
const Payment = {
  "ID": true,
  "PAYSYSTEM_ID": true,
  "PAYSYSTEM": {
    "__fragment": "Paysystem"
  },
  "IS_PAID": true,
  "SUM": true,
  "SUM_PAID": true,
  "PAY_NAV": true,
  "PS_STATUS": true,
  "PS_STATUS_CODE": true,
  "PS_STATUS_ID": true,
  "PS_STATUS_NAME": true,
  "PS_INVOICE_ID": true,
  "ORDER_ID": true,
  "ORDER_URL": true,
  "DATE_PAID": true
}
const OrderScope = {
  "CONTRACT_NUM": true,
  "ENTITY_TYPE": true,
  "ENTITY_ID": true
}
const Coupon = {
  "ID": true,
  "NAME": true,
  "COUPON": true,
  "PRODUCT_ID": true,
  "PRODUCT": {
    "__fragment": "Product"
  }
}
const CourierState = {
  "COORDS": true,
  "ARRIVAL_TIME_CAPTION": true,
  "ARRIVAL_TIME": true,
  "CAR_COLOR": true,
  "CAR_NUMBER": true
}
const OrderCancelReason = {
  "CODE": true,
  "NAME": true
}
const OrderAttributesValue = {
  "DETAILS": true,
  "UUID": true,
  "FIO": true,
  "PHONE": true,
  "EMAIL": true,
  "DELIVERY_TYPE": true,
  "DELIVERY_DEPARTMENT": true,
  "STREET_PATH": true,
  "CITY": true,
  "CITY_FIAS_ID": true,
  "SETTLEMENT": true,
  "SETTLEMENT_FIAS_ID": true,
  "STREET_FIAS_ID": true,
  "STREET_COORDS": {
    "__fragment": "Coordinates"
  },
  "HOUSE": true,
  "HOUSE_FIAS_ID": true,
  "HOUSE_COORDS": {
    "__fragment": "Coordinates"
  },
  "FLAT": true,
  "LOCATION": true,
  "INTERCOM": true,
  "FLOOR": true,
  "ENTRANCE": true,
  "PRIVATE_HOUSE": true,
  "LIFT": true,
  "PICKUP_DEPARTMENT": true,
  "TIME_MODE": {},
  "DATE": true,
  "TIME": true,
  "PAYMENT_TYPE": {},
  "CASH_SUM": true,
  "BONUSES": true,
  "PROMOCODE": true,
  "DELIVERY_PRICE": true,
  "RECEIVER_NAME": true,
  "RECEIVER_ANOTHER": true,
  "RECEIVER_PHONE": true,
  "PERSONS_NUMBER": true,
  "COMMENT": true,
  "GIFTS_LIST": true,
  "WITH_OPERATOR": true,
  "ROISTAT": true,
  "NEED_CONFIRM": true,
  "PROFILE_COMMENT": true,
  "ADDRESS_SOURCE": true,
  "PROFILE_ID": true,
  "ADDRESS_IS_CUSTOM": true,
  "PROFILE_DEFAULT": true,
  "VORDER_ID": true,
  "SERVICE_SEND": true,
  "DATETIME": true,
  "SERVICE_SEND_START": true,
  "DATA": {
    "__fragment": "OrderData"
  },
  "RESERVE_SUCCESS_HASH": true,
  "DISCOUNT_REASON": true,
  "DISCOUNT_PERCENT": true,
  "ADDRESS": true,
  "BENEFIT_TYPE": {},
  "DELIVERY_FREE_FROM_PRICE": true,
  "STREET": true,
  "DEPARTMENT_SERVICE_ID": true,
  "DELIVERY_FREE_UPDATED_TIME": true,
  "IS_ACCEPTED": true,
  "TEST_TIME": true,
  "STRUCT": true,
  "TRANSPORT_TYPE": {},
  "COUPON_ID": true,
  "PRIZE_ID": true,
  "SESSION_ID": true,
  "PAYMENT_GIFT": true,
  "TEST_TIME_NEW": true,
  "APP_VERSION": true,
  "SOURCE": true,
  "RESERVE_REQUEST_TIME": true,
  "UTM_SOURCE": true,
  "RESERVE_AVAILABLE_TIME": true,
  "RESERVE_NEED_TIME": true,
  "RESERVE_STATUS": true,
  "RESERVE_SUCCESS_REQUEST_TIME": true,
  "UTM_MEDIUM": true,
  "UTM_CAMPAIGN": true,
  "UTM_TERM": true,
  "UTM_CONTENT": true,
  "UTM_LANDING_URL": true,
  "DELIVERY_ID": true,
  "PAY_SYSTEM_ID": true,
  "USER_DESCRIPTION": true
}
const OrderData = {
  "paramInt": true,
  "paramString": true,
  "paramArray": true
}
const OrderAttributesView = {
  "DETAILS": true,
  "UUID": true,
  "FIO": true,
  "PHONE": true,
  "EMAIL": true,
  "DELIVERY_TYPE": true,
  "DELIVERY_DEPARTMENT": true,
  "STREET_PATH": true,
  "CITY": true,
  "CITY_FIAS_ID": true,
  "SETTLEMENT": true,
  "SETTLEMENT_FIAS_ID": true,
  "STREET_FIAS_ID": true,
  "STREET_COORDS": true,
  "HOUSE": true,
  "HOUSE_FIAS_ID": true,
  "HOUSE_COORDS": true,
  "FLAT": true,
  "LOCATION": true,
  "INTERCOM": true,
  "FLOOR": true,
  "ENTRANCE": true,
  "PRIVATE_HOUSE": true,
  "LIFT": true,
  "PICKUP_DEPARTMENT": true,
  "TIME_MODE": true,
  "DATE": true,
  "TIME": true,
  "PAYMENT_TYPE": true,
  "CASH_SUM": true,
  "BONUSES": true,
  "PROMOCODE": true,
  "DELIVERY_PRICE": true,
  "RECEIVER_NAME": true,
  "RECEIVER_ANOTHER": true,
  "RECEIVER_PHONE": true,
  "PERSONS_NUMBER": true,
  "COMMENT": true,
  "GIFTS_LIST": true,
  "WITH_OPERATOR": true,
  "ROISTAT": true,
  "NEED_CONFIRM": true,
  "PROFILE_COMMENT": true,
  "ADDRESS_SOURCE": true,
  "PROFILE_ID": true,
  "ADDRESS_IS_CUSTOM": true,
  "PROFILE_DEFAULT": true,
  "VORDER_ID": true,
  "SERVICE_SEND": true,
  "DATETIME": true,
  "SERVICE_SEND_START": true,
  "DATA": true,
  "RESERVE_SUCCESS_HASH": true,
  "DISCOUNT_REASON": true,
  "DISCOUNT_PERCENT": true,
  "ADDRESS": true,
  "BENEFIT_TYPE": true,
  "DELIVERY_FREE_FROM_PRICE": true,
  "STREET": true,
  "DEPARTMENT_SERVICE_ID": true,
  "DELIVERY_FREE_UPDATED_TIME": true,
  "IS_ACCEPTED": true,
  "TEST_TIME": true,
  "STRUCT": true,
  "TRANSPORT_TYPE": true,
  "COUPON_ID": true,
  "PRIZE_ID": true,
  "SESSION_ID": true,
  "PAYMENT_GIFT": true,
  "TEST_TIME_NEW": true,
  "APP_VERSION": true,
  "SOURCE": true,
  "RESERVE_REQUEST_TIME": true,
  "UTM_SOURCE": true,
  "RESERVE_AVAILABLE_TIME": true,
  "RESERVE_NEED_TIME": true,
  "RESERVE_STATUS": true,
  "RESERVE_SUCCESS_REQUEST_TIME": true,
  "UTM_MEDIUM": true,
  "UTM_CAMPAIGN": true,
  "UTM_TERM": true,
  "UTM_CONTENT": true,
  "UTM_LANDING_URL": true,
  "DELIVERY_ID": true,
  "PAY_SYSTEM_ID": true,
  "USER_DESCRIPTION": true
}
const OrderAttribute = {
  "KIND": {},
  "TYPE": {},
  "CODE": {},
  "NAME": true,
  "DEFAULT_VALUE": true,
  "VALUE": true,
  "VALUE_VIEW": true,
  "OPTIONS": {
    "__fragment": "OrderAttributeOption"
  }
}
const OrderAttributeOption = {
  "ID": true,
  "VALUE": true,
  "NAME": true,
  "NAME_SHORT": true,
  "SORT": true,
  "DESCRIPTION": true,
  "XML_ID": true,
  "ICON": true,
  "DISABLE": true
}
const AppProductRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "Product"
  }
}
const SearchResult = {
  "ELEMENTS": {
    "__fragment": "Product"
  },
  "SECTIONS": {
    "__fragment": "Section"
  }
}
const VorderCurrent = {
  "TS": true,
  "DELIVERY_PRICE_RULES": {
    "__fragment": "DeliveryPriceRule"
  },
  "BONUSES_AVAILABLE": true,
  "BONUSES_PERCENT": true,
  "PERSON_TYPES": {
    "__fragment": "PersonType"
  },
  "PAYMENT_TYPES": {
    "__fragment": "PaymentType"
  },
  "PROFILES": {
    "__fragment": "OrderProfile"
  },
  "DEPARTMENTS": {
    "__fragment": "CompanyOffice"
  },
  "DISCOUNTS": {
    "__fragment": "Discount"
  },
  "DELIVERIES": {
    "__fragment": "DeliveryComputed"
  },
  "TRANSPORT_TYPES": {
    "__fragment": "TransportType"
  },
  "DELIVERY_CALCULATED": true,
  "DELIVERY_FREE_FROM_PRICE": true,
  "COUPON_CAN_ADD": true,
  "RESPONSE_STATE": {
    "__fragment": "ResponseState"
  },
  "BASKET_RULES": {
    "__fragment": "BasketRule"
  },
  "ID": true,
  "SESSION_ID": true,
  "FUSER_ID": true,
  "USER_ID": true,
  "USER": {
    "__fragment": "User"
  },
  "ORDER_ID": true,
  "FIELDS_RAW": true,
  "PROPS_RAW": true,
  "PHONE": true,
  "EMAIL": true,
  "ORDER": {
    "__fragment": "Order"
  },
  "PROFILE_ID": true,
  "DELIVERY_DEPARTMENT_ID": true,
  "PICKUP_DEPARTMENT_ID": true,
  "DEPARTMENT_ID": true,
  "BONUSES": true,
  "COUPONS": {
    "__fragment": "Coupon"
  },
  "BASKET": {
    "__fragment": "Basket"
  },
  "ATTR": {
    "__fragment": "OrderAttributesValue"
  },
  "ATTRS": {
    "__fragment": "OrderAttribute"
  }
}
const DeliveryPriceRule = {
  "DATE": true,
  "PRICE": true
}
const PersonType = {
  "ID": true,
  "NAME": true,
  "SORT": true,
  "CODE": true,
  "RESTRICTED": true,
  "IS_COMPANY": true
}
const PaymentType = {
  "CODE": true,
  "NAME": true,
  "ICON": true
}
const OrderProfile = {
  "ID": true,
  "NAME": true,
  "CAPTION": true,
  "USER_ID": true,
  "USER": {
    "__fragment": "User"
  },
  "PERSON_TYPE_ID": true,
  "PERSON_TYPE": {
    "__fragment": "PersonType"
  },
  "COMPANY_ID": true,
  "IS_DEFAULT": true,
  "COORDS": {
    "__fragment": "Coordinates"
  },
  "DELIVERY_FREE_FROM_PRICE": true,
  "ATTR": {
    "__fragment": "OrderProfileAttributesValue"
  },
  "ATTRS": {
    "__fragment": "OrderAttribute"
  }
}
const OrderProfileAttributesValue = {
  "STREET_PATH": true,
  "CITY": true,
  "CITY_FIAS_ID": true,
  "SETTLEMENT": true,
  "SETTLEMENT_FIAS_ID": true,
  "STREET_FIAS_ID": true,
  "STREET_COORDS": {
    "__fragment": "Coordinates"
  },
  "HOUSE": true,
  "HOUSE_FIAS_ID": true,
  "HOUSE_COORDS": {
    "__fragment": "Coordinates"
  },
  "FLAT": true,
  "FLOOR": true,
  "ENTRANCE": true,
  "PRIVATE_HOUSE": true,
  "LIFT": true,
  "RECEIVER_NAME": true,
  "RECEIVER_ANOTHER": true,
  "RECEIVER_PHONE": true,
  "PROFILE_COMMENT": true,
  "ADDRESS_SOURCE": true,
  "ADDRESS_IS_CUSTOM": true,
  "PROFILE_DEFAULT": true,
  "ADDRESS": true,
  "STREET": true
}
const Discount = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "DiscountProps"
  },
  "CONDITION": {
    "__fragment": "OrderCondition"
  },
  "DISCOUNT_PERCENT": true,
  "DISCOUNT_TARGET": {}
}
const DiscountProps = {
  "TRANSPORT_TYPE": {},
  "PAYMENT_TYPE": {},
  "PRODUCT_ENTITIES": {
    "__fragment": "Element"
  },
  "PRODUCT": true,
  "PRODUCT_SECTION": true,
  "ORDER_PRICE_FROM": true,
  "NAME_TEMPLATE": true,
  "HOTEST": true,
  "DISCOUNT_PERCENT": true,
  "DELIVERY_DISCOUNT": true,
  "PRIZE_ENTITY": {
    "__fragment": "Element"
  },
  "PRIZE": true,
  "DISCOUNT_TARGET": {},
  "BENEFIT_TYPE": {}
}
const OrderCondition = {
  "BENEFIT_TYPE": {},
  "PAYMENT_TYPE": {},
  "TRANSPORT_TYPE": {},
  "PRODUCT_SECTION": true,
  "PRODUCT": true,
  "OFFICE_ROLE": {},
  "OFFICE": true,
  "ORDER_PRICE_FROM": true,
  "COUPON": true,
  "PRIZE": true
}
const DeliveryComputed = {
  "ID": true,
  "NAME": true,
  "SERVICE": {
    "__fragment": "DeliveryWrapper"
  },
  "CALC_TIMESTAMP": true,
  "PRICE": true,
  "PRICE_FORMATED": true,
  "DELIVERY_DISCOUNT_PRICE": true,
  "DELIVERY_DISCOUNT_PRICE_FORMATED": true,
  "PERIOD_TEXT": true,
  "CALCULATE_ERRORS": true,
  "CALCULATE_DESCRIPTION": true
}
const DeliveryWrapper = {
  "ID": true,
  "NAME": true,
  "TRANSPORT_TYPE": {},
  "HOST": {
    "__fragment": "DeliveryService"
  }
}
const TransportType = {
  "CODE": true,
  "NAME": true,
  "ICON": true,
  "DISCOUNT": true
}
const ResponseState = {
  "messages": {
    "__fragment": "Message"
  },
  "events": true,
  "rate": {
    "__fragment": "ResponseRate"
  },
  "redirect": {
    "__fragment": "ResponseRedirect"
  }
}
const Message = {
  "id": true,
  "type": {},
  "code": true,
  "name": true,
  "status": true,
  "title": true,
  "message": true,
  "messages": true,
  "category": true,
  "notify": true,
  "rel": true,
  "duration": true,
  "data": true,
  "actions": {
    "__fragment": "MenuItem"
  }
}
const ResponseRate = {
  "ttl": true,
  "limited": true
}
const ResponseRedirect = {
  "ttl": true,
  "restricted": true
}
const BasketRule = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "BasketRuleProps"
  },
  "TYPE": {},
  "NAME_TEMPLATE": true,
  "ALL_STOP": true,
  "IS_ADDITIONAL": true,
  "CONDITION": {
    "__fragment": "OrderCondition"
  },
  "BENEFITS": {},
  "PROMO": true
}
const BasketRuleProps = {
  "TYPE": {},
  "CAPTION": true,
  "NAME_TEMPLATE": true,
  "IS_ADDITIONAL": true,
  "ALL_STOP": true,
  "CONDITION_PAYMENT_TYPE": {},
  "CONDITION_TRANSPORT_TYPE": {},
  "CONDITION_ORDER_PRICE_FROM": true,
  "CONDITION_PRODUCT_SECTION": true,
  "CONDITION_PRODUCT_ENTITIES": {
    "__fragment": "Element"
  },
  "CONDITION_PRODUCT": true,
  "CONDITION_OFFICE_ENTITIES": {
    "__fragment": "Element"
  },
  "CONDITION_OFFICE": true,
  "CONDITION_OFFICE_ROLE": {},
  "CONDITION_BENEFIT_TYPE": {},
  "CONDITION_COUPON_ENTITY": {
    "__fragment": "Element"
  },
  "CONDITION_COUPON": true,
  "CONDITION_PRIZE_ENTITY": {
    "__fragment": "Element"
  },
  "CONDITION_PRIZE": true,
  "BENEFITS": {
    "__fragment": "BasketRulePropsBenefits"
  },
  "DISCOUNT_PERCENT": true,
  "BENEFITS_PRODUCT_ID_ENTITIES": {
    "__fragment": "Element"
  },
  "PRODUCT_ID": true
}
const BasketRulePropsBenefits = {
  "TYPE": {},
  "DISCOUNT_PERCENT": true,
  "PRODUCT_ID": true,
  "UID": true
}
const Basket = {
  "TS": true,
  "SYNCED": true,
  "BASE_PRICE": true,
  "PRICE": true,
  "COUNT": true,
  "QUANTITY": true,
  "ITEMS": {
    "__fragment": "BasketItem"
  },
  "WEIGHT": true,
  "MIN_PRICE": true,
  "MIN_PRICE_REACHED": true,
  "HASH": true,
  "OFFERS": {
    "__fragment": "SpecialOffer"
  },
  "GIFTS": true,
  "CLIENT_CHANGED_AT": true
}
const SpecialOffer = {
  "MIN_PRICE": true,
  "MODE": true,
  "ELEMENT_ID": true,
  "ELEMENT": {
    "__fragment": "Product"
  },
  "TYPE": true,
  "TYPE_INFO": {
    "__fragment": "SpecialOfferType"
  }
}
const SpecialOfferType = {
  "NAME": true,
  "CODE": true,
  "COLOR": true
}
const VorderSummary = {
  "ID": true,
  "PHONE": true,
  "EMAIL": true,
  "FUSER_ID": true
}
const OrderProfileRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "OrderProfile"
  }
}
const SaleClientCard = {
  "ID": true,
  "BONUSES": true,
  "FETCHED": true,
  "FETCHED_TIME_FORMATTED": true,
  "FETCHED_TIME": true,
  "USER_ID": true,
  "CLIENT_PHONE": true,
  "LEVEL_CODE": true,
  "LEVEL_NAME": true,
  "MONTH_SPENT": true,
  "BONUSES_EXPIRE_FORMATTED": true,
  "BONUSES_EXPIRE": true,
  "BONUSES_PERCENT": true,
  "DIS_FIRST_ORDER": true,
  "DIS_SELF_PICKUP": true,
  "LEVEL": {
    "__fragment": "BonusLevel"
  },
  "DISCOUNTS": {
    "__fragment": "Discount"
  },
  "FETCHED_ACTUAL": true,
  "EXPIRED": true
}
const BonusLevel = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "BonusLevelProps"
  }
}
const BonusLevelProps = {
  "ORDERS_SUMM": true,
  "ACCUMULATION_PERCENT": true,
  "MAX_USE_PERCENT": true,
  "COLOR": true,
  "MONTH_SPENT_MIN": true,
  "MONTH_SPENT_MAX": true
}
const ClientCardRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "SaleClientCard"
  }
}
const DeliveryZone = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PROPERTIES": {
    "__fragment": "DeliveryZoneProps"
  }
}
const DeliveryZoneProps = {
  "PRICE_TEXT": true,
  "PRICE_BY_DELIVERY": true,
  "PRICE_BY_KM": true,
  "FREE_TEXT": true,
  "FREE_FROM_PRICE": true,
  "GEOJSON": true,
  "OUTSIDE": true,
  "COLOR": true
}
const ProductIngredient = {
  "ID": true,
  "NAME": true,
  "IBLOCK_SECTION_ID": true,
  "URL": true,
  "PROPERTIES": {
    "__fragment": "ProductIngredientProps"
  }
}
const ProductIngredientProps = {
  "SHOW_IN_FILTER": true,
  "ALIASES": true
}
const Modificator = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "SECTION": {
    "__fragment": "ModificatorSection"
  },
  "TYPE": {},
  "LIMIT": true,
  "QUANTITY_LIMIT": true,
  "REQUIRED": true,
  "IS_GLOBAL": true,
  "ORDER_PRICE_FROM": true,
  "CONDITION": {
    "__fragment": "OrderCondition"
  },
  "PRODUCT_COMPONENT": true,
  "PRODUCT_COMPONENT_PROPS": true,
  "PRODUCT_COMPONENT_STYLE": true,
  "OPTIONS": {
    "__fragment": "ModificatorOption"
  },
  "CODE_PATH": true,
  "ID_PATH": true,
  "DEFAULT_VALUE": true,
  "GROUP_CODE": true,
  "POSITIONS": true,
  "OPTION_INFO_TYPE": {},
  "FEATURES": true,
  "PROPERTIES": {
    "__fragment": "ModificatorProps"
  }
}
const ModificatorSection = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_TYPE_ID": true,
  "IBLOCK_EXTERNAL_ID": true,
  "EXTERNAL_ID": true,
  "IBLOCK_SECTION_ID": true,
  "TIMESTAMP_X": true,
  "ACTIVE": true,
  "PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DESCRIPTION": true,
  "DESCRIPTION_TYPE": true,
  "LEFT_MARGIN": true,
  "RIGHT_MARGIN": true,
  "DEPTH_LEVEL": true,
  "SEARCHABLE_CONTENT": true,
  "SECTION_PAGE_URL": true,
  "DATE_CREATE": true,
  "PARENT": {
    "__fragment": "ModificatorSection"
  },
  "PARENTS": {
    "__fragment": "ModificatorSection"
  },
  "ELEMENT_CNT": true,
  "META": {
    "__fragment": "ElementMeta"
  },
  "REPLACE_LINK": true,
  "CHILDREN": {
    "__fragment": "Section"
  },
  "PROPERTIES": {
    "__fragment": "ModificatorSectionProps"
  }
}
const ModificatorSectionProps = {
  "LIMIT": true,
  "TYPE": {},
  "REQUIRED": true,
  "QUANTITY_LIMIT": true,
  "PRODUCT_COMPONENT": true,
  "PRODUCT_COM_PROPS": true,
  "IS_GROUP": true,
  "PRODUCT_COM_STYLE": true,
  "CARD_POS": {},
  "OPTION_INFO_TYPE": {}
}
const ModificatorOption = {
  "UID": true,
  "NAME": true,
  "PRODUCT_ID": true,
  "QUANTITY": true,
  "QUANTITY_LIMIT": true,
  "IMAGE": {
    "__fragment": "Image"
  },
  "DEFAULT": true
}
const ModificatorProps = {
  "OVERRIDE_PARENT": true,
  "TYPE": {},
  "REQUIRED": {},
  "LIMIT": true,
  "QUANTITY_LIMIT": true,
  "PRODUCT_COMPONENT": true,
  "PRODUCT_COMPONENT_PROPS": true,
  "PRODUCT_COMPONENT_STYLE": true,
  "CARD_POSITION": {},
  "DETAIL_POSITION": {},
  "PRODUCTS": {
    "__fragment": "ModificatorPropsProducts"
  },
  "PRODUCTS_PRODUCT_ID_ENTITIES": {
    "__fragment": "Element"
  },
  "PRODUCT_ID": true,
  "QUANTITY": true,
  "UID": true,
  "NAME": true,
  "IMAGE": {
    "__fragment": "Image"
  },
  "DEFAULT": true
}
const ModificatorPropsProducts = {
  "PRODUCT_ID": true,
  "QUANTITY": true,
  "QUANTITY_LIMIT": true,
  "UID": true,
  "NAME": true,
  "IMAGE": {
    "__fragment": "Image"
  },
  "DEFAULT": true
}
const ProductFlag = {
  "ID": true,
  "NAME": true,
  "IBLOCK_SECTION_ID": true,
  "URL": true,
  "PROPERTIES": {
    "__fragment": "ProductFlagProps"
  }
}
const ProductFlagProps = {
  "NAME_SHORT": true,
  "TEXT_COLOR": true,
  "BG_COLOR": true,
  "IMAGE": {
    "__fragment": "Image"
  },
  "ICON": true,
  "CLASS": true
}
const OrderRestriction = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "OrderRestrictionProps"
  },
  "SCHEDULE": true,
  "SCHEDULE_DESC": true,
  "SCHEDULE_ACTIVE": true,
  "CONDITION": {
    "__fragment": "OrderCondition"
  },
  "ITEM_ERROR_NAME": true,
  "ITEM_MESSAGE": true,
  "MESSAGE": true
}
const OrderRestrictionProps = {
  "TRANSPORT_TYPE": {},
  "OFFICE_ROLE": {},
  "OFFICE_ENTITIES": {
    "__fragment": "Element"
  },
  "OFFICE": true,
  "PAYMENT_TYPE": {},
  "PRODUCT_ENTITIES": {
    "__fragment": "Element"
  },
  "PRODUCT": true,
  "PRODUCT_SECTION": true,
  "MESSAGE": true,
  "ITEM_MESSAGE": true,
  "SCHEDULE": true,
  "ITEM_ERROR_NAME": {},
  "SECTION": {}
}
const ProductSection = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_TYPE_ID": true,
  "IBLOCK_EXTERNAL_ID": true,
  "EXTERNAL_ID": true,
  "IBLOCK_SECTION_ID": true,
  "TIMESTAMP_X": true,
  "ACTIVE": true,
  "PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DESCRIPTION": true,
  "DESCRIPTION_TYPE": true,
  "LEFT_MARGIN": true,
  "RIGHT_MARGIN": true,
  "DEPTH_LEVEL": true,
  "SEARCHABLE_CONTENT": true,
  "SECTION_PAGE_URL": true,
  "DATE_CREATE": true,
  "PARENT": {
    "__fragment": "ProductSection"
  },
  "PARENTS": {
    "__fragment": "ProductSection"
  },
  "ELEMENT_CNT": true,
  "META": {
    "__fragment": "ElementMeta"
  },
  "REPLACE_LINK": true,
  "CHILDREN": {
    "__fragment": "Section"
  },
  "PROPERTIES": {
    "__fragment": "ProductSectionProps"
  },
  "FEATURE_IDS": true
}
const ProductSectionProps = {
  "MENU_BG_COLOR": true,
  "TITLE_IRKUTSK": true,
  "DESCR_IRKUTSK": true,
  "H1_IRKUTSK": true,
  "TITLE_ANGARSK": true,
  "DESCR_ANGARSK": true,
  "H1_ANGARSK": true,
  "TITLE_KRASNOYARSK": true,
  "DESCR_KRASNOYARSK": true,
  "H1_KRASNOYARSK": true,
  "NAV_URL": true,
  "NAV_TITLE": true,
  "HINT": true,
  "CATEGORY_CLASS": true,
  "SEARCH_IN": true,
  "REPLACE_LINK": true,
  "M_CARD": true,
  "MENU_ICON": {
    "__fragment": "Image"
  },
  "MENU_FOCUSED_ICON": {
    "__fragment": "Image"
  },
  "MENU_ITEM_STYLE": {},
  "MENU_COLOR": true,
  "UPSALE_SECTIONS": true,
  "MODIFICATORS_ENTITY": {
    "__fragment": "Modificator"
  },
  "MODIFICATORS": true
}
const ClientSegment = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  }
}
const ClientSegmentRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "ClientSegment"
  }
}
const Feature = {
  "ACTIVE": true,
  "AVAILABLE": {
    "__fragment": "AvailableStatus"
  },
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "FeatureProps"
  }
}
const AvailableStatus = {
  "STATUS": true,
  "REASON": true
}
const FeatureProps = {
  "MODEL_CLASS": true,
  "SEGMENTS_ENTITIES": {
    "__fragment": "Element"
  },
  "SEGMENTS": true,
  "SCHEDULE_ENABLE": true,
  "SCHEDULE": true
}
const FeatureRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "Feature"
  }
}
const CallTrackingPhone = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  },
  "PROPERTIES": {
    "__fragment": "CallTrackingPhoneProps"
  },
  "PHONE_NUMBER": true,
  "IS_DEFAULT": true,
  "IS_RESERVED": true
}
const CallTrackingPhoneProps = {
  "PHONE_NUMBER": true,
  "CLIENT_ID": true,
  "USER_ID": true,
  "RESERVED_AT": true,
  "IS_DEFAULT": true
}
const YandexMetricGoal = {
  "ID": true,
  "NAME": true,
  "CODE": true,
  "SORT": true,
  "IBLOCK_ID": true,
  "IBLOCK_CODE": true,
  "IBLOCK_SECTION_ID": true,
  "ACTIVE": true,
  "ACTIVE_FROM": true,
  "ACTIVE_TO": true,
  "TIMESTAMP_X": true,
  "DATE_CREATE": true,
  "CREATED_BY": true,
  "CREATED_USER_NAME": true,
  "MODIFIED_BY": true,
  "PREVIEW_PICTURE": {
    "__fragment": "Image"
  },
  "PREVIEW_TEXT": true,
  "PREVIEW_TEXT_TYPE": true,
  "DETAIL_PICTURE": {
    "__fragment": "Image"
  },
  "DETAIL_TEXT": true,
  "DETAIL_TEXT_TYPE": true,
  "SHOW_COUNTER": true,
  "SHOW_COUNTER_START": true,
  "TAGS": true,
  "XML_ID": true,
  "EXTERNAL_ID": true,
  "SECTION_ID": true,
  "IBLOCK_SECTION_IDS": true,
  "URL": true,
  "PATH": {
    "__fragment": "Section"
  },
  "SECTIONS": {
    "__fragment": "Section"
  },
  "SECTION": {
    "__fragment": "Section"
  },
  "ROOT_SECTION": {
    "__fragment": "Section"
  },
  "META": {
    "__fragment": "ElementMeta"
  }
}
const YandexMetricGoalRecordset = {
  "info": {
    "__fragment": "QueryInfo"
  },
  "nodes": {
    "__fragment": "YandexMetricGoal"
  }
}
const TestmutationcreateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "TestItem"
  }
}
const TestmutationupdateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "TestItem"
  }
}
const Response = {
  "success": true,
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": true,
  "error": {},
  "errors": {}
}
const NoticePubSyncReadedResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "ClientNotice"
  }
}
const UserAuthLoginStartResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "UserAuthLoginStartResultPayload"
  }
}
const UserAuthLoginStartResultPayload = {
  "confirmModes": {
    "__fragment": "UserAuthConfirm"
  },
  "discounts": {
    "__fragment": "Discount"
  }
}
const UserAuthConfirm = {
  "NAME": true,
  "CODE": true,
  "COLOR": true,
  "ICON": true,
  "LIST_NAME": true,
  "LIST_CAPTION": true,
  "LIST_BUTTON_MOBILE": {
    "__fragment": "MenuItemMobile"
  },
  "LIST_BUTTON_WEB": {
    "__fragment": "MenuItem"
  },
  "CONFIRM_CONTENT_MOBILE": true,
  "CONFIRM_CONTENT_WEB": true,
  "CONFIRM_STEPS": {
    "__fragment": "UserAuthConfirmStep"
  },
  "RESEND_TITLE": true
}
const UserAuthConfirmStep = {
  "CODE": true,
  "NAME": true,
  "CAPTION": true
}
const UserAuthLoginRequestResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "UserAuthLoginRequestResultPayload"
  }
}
const UserAuthLoginRequestResultPayload = {
  "rateTtl": true
}
const UserAuthLoginConfirmResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "UserAuthLoginConfirmResultPayload"
  }
}
const UserAuthLoginConfirmResultPayload = {
  "appClient": {
    "__fragment": "AppClient"
  },
  "sessionId": true,
  "userId": true,
  "redirect": true,
  "isNew": true
}
const UserProfileNameResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "User"
  }
}
const UserProfileBirthdayResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "User"
  }
}
const UserProfileEmailResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "User"
  }
}
const CompanyOfficeUpdateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "CompanyOffice"
  }
}
const PushSubscribeResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "PushSubscribeResultPayload"
  }
}
const PushSubscribeResultPayload = {
  "appClient": {
    "__fragment": "AppClient"
  }
}
const PushUnsubscribeResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "PushUnsubscribeResultPayload"
  }
}
const PushUnsubscribeResultPayload = {
  "appClient": {
    "__fragment": "AppClient"
  }
}
const PushSendTestResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "PushSendTestResultPayload"
  }
}
const PushSendTestResultPayload = {
  "success": true,
  "sent": true,
  "failed": true
}
const FortuneSpinResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "FortuneSpinResultPayload"
  }
}
const FortuneSpinResultPayload = {
  "userPrize": {
    "__fragment": "FortuneUserPrize"
  }
}
const TelegramCreateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "TelegramChat"
  }
}
const TelegramUpdateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "TelegramChat"
  }
}
const TelegramAuthByPhoneResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "TelegramAuthByPhoneResultPayload"
  }
}
const TelegramAuthByPhoneResultPayload = {
  "userId": true,
  "userName": true,
  "phone": true,
  "token": true,
  "chatId": true
}
const ReviewServiceReviewResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "Review"
  }
}
const ReviewOrderGuestReviewResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "ReviewOrderGuestReviewResultPayload"
  }
}
const ReviewOrderGuestReviewResultPayload = {
  "redirectUrl": true,
  "departmentId": true,
  "departmentName": true
}
const SaleOrderTestResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "SaleOrderTestResultPayload"
  }
}
const SaleOrderTestResultPayload = {
  "num": true
}
const SaleOrderPayOnlineResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "SaleOrderPayOnlineResultPayload"
  }
}
const SaleOrderPayOnlineResultPayload = {
  "paymentUrl": true,
  "price": true,
  "order": {
    "__fragment": "Order"
  }
}
const SaleOrderRepeatResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "Order"
  }
}
const SaleOrderCancelResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "Order"
  }
}
const VorderNewResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "VorderNewResultPayload"
  }
}
const VorderNewResultPayload = {
  "vorder": {
    "__fragment": "Vorder"
  }
}
const Vorder = {
  "ID": true,
  "SESSION_ID": true,
  "FUSER_ID": true,
  "USER_ID": true,
  "USER": {
    "__fragment": "User"
  },
  "ORDER_ID": true,
  "FIELDS_RAW": true,
  "PROPS_RAW": true,
  "PHONE": true,
  "EMAIL": true,
  "ORDER": {
    "__fragment": "Order"
  },
  "PROFILE_ID": true,
  "DELIVERY_DEPARTMENT_ID": true,
  "PICKUP_DEPARTMENT_ID": true,
  "DEPARTMENT_ID": true,
  "BONUSES": true,
  "COUPONS": {
    "__fragment": "Coupon"
  },
  "BASKET": {
    "__fragment": "Basket"
  },
  "ATTR": {
    "__fragment": "OrderAttributesValue"
  },
  "ATTRS": {
    "__fragment": "OrderAttribute"
  }
}
const VorderApplyResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "VorderApplyResultPayload"
  }
}
const VorderApplyResultPayload = {
  "vorder": {
    "__fragment": "Vorder"
  }
}
const VorderBasketResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "VorderBasketResultPayload"
  }
}
const VorderBasketResultPayload = {
  "vorder": {
    "__fragment": "Vorder"
  }
}
const VorderDeliveryCalculateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "VorderDeliveryCalculateResultPayload"
  }
}
const VorderDeliveryCalculateResultPayload = {
  "vorder": {
    "__fragment": "VorderCurrent"
  },
  "calc": {
    "__fragment": "DeliveryCalculate"
  }
}
const DeliveryCalculate = {
  "ID": true,
  "VORDER_ID": true,
  "REQUEST_DELTA": true,
  "DELIVERY_HASH": true,
  "ORDER_ID": true,
  "DELIVERY_ADDRESS": true,
  "REQUEST_TIME_FORMATTED": true,
  "REQUEST_TIME": true,
  "NEED_TIME_FORMATTED": true,
  "NEED_TIME": true,
  "ORDER_PRICE": true,
  "RES_DELIVER_PRICE": true,
  "RES_TIME_FORMATTED": true,
  "RES_TIME": true,
  "RES_OFFICE_1C_ID": true,
  "RES_OFFICE_ID": true,
  "ADDRESS_COORDS": true,
  "PHONE": true,
  "RES_STATUS": {},
  "TRANSPORT_TYPE": true,
  "TIME_MODE": {}
}
const VorderCouponResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "VorderCouponResultPayload"
  }
}
const VorderCouponResultPayload = {
  "vorder": {
    "__fragment": "VorderCurrent"
  },
  "coupon": {
    "__fragment": "Coupon"
  }
}
const VorderSubmitResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "VorderSubmitResultPayload"
  }
}
const VorderSubmitResultPayload = {
  "vorder": {
    "__fragment": "VorderCurrent"
  },
  "newVorderId": true,
  "orderId": true,
  "orderUrl": true,
  "order": {
    "__fragment": "Order"
  },
  "activeOrders": {
    "__fragment": "Order"
  }
}
const VorderSyncResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "VorderSyncResultPayload"
  }
}
const VorderSyncResultPayload = {
  "vorder": {
    "__fragment": "Vorder"
  }
}
const SaleProfileDefaultResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "OrderProfile"
  }
}
const SaleProfileDeleteResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": true
}
const SaleProfileSaveResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "OrderProfile"
  }
}
const SaleProfileCalcDeliveryResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "DeliveryCalculate"
  }
}
const SaleClientCardCreateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "SaleClientCard"
  }
}
const SaleClientCardUpdateResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "SaleClientCard"
  }
}
const CallTrackingRequestPhoneResult = {
  "success": true,
  "errors": {},
  "error": {},
  "state": {
    "__fragment": "ResponseState"
  },
  "payload": {
    "__fragment": "CallTrackingRequestPhoneResultPayload"
  }
}
const CallTrackingRequestPhoneResultPayload = {
  "phone": {
    "__fragment": "CallTrackingPhone"
  }
}
import {BasketItemFields} from '@/gql/fragments/BasketItemFields'
import {BasketRuleConditionFields} from '@/gql/fragments/BasketRuleConditionFields'
import {BasketRuleFields} from '@/gql/fragments/BasketRuleFields'
import {BonusLevelFields} from '@/gql/fragments/BonusLevelFields'
import {CallTrackingPhoneFields} from '@/gql/fragments/CallTrackingPhoneFields'
import {ClientCardFields} from '@/gql/fragments/ClientCardFields'
import {CouponFields} from '@/gql/fragments/CouponFields'
import {DeliveryCalculateFields} from '@/gql/fragments/DeliveryCalculateFields'
import {DeliveryZoneFields} from '@/gql/fragments/DeliveryZoneFields'
import {DiscountFields} from '@/gql/fragments/DiscountFields'
import {ErrorFields} from '@/gql/fragments/ErrorFields'
import {FaqQuestionFields} from '@/gql/fragments/FaqQuestionFields'
import {FeatureFields} from '@/gql/fragments/FeatureFields'
import {FortunePrizeFields} from '@/gql/fragments/FortunePrizeFields'
import {FortuneUserPrizeFields} from '@/gql/fragments/FortuneUserPrizeFields'
import {MenuFields} from '@/gql/fragments/MenuFields'
import {MenuItemBaseFields} from '@/gql/fragments/MenuItemBaseFields'
import {MenuItemFields} from '@/gql/fragments/MenuItemFields'
import {ModificatorFields} from '@/gql/fragments/ModificatorFields'
import {NoticeFields} from '@/gql/fragments/NoticeFields'
import {OfferFields} from '@/gql/fragments/OfferFields'
import {OfficeFields} from '@/gql/fragments/OfficeFields'
import {OrderAttrsFields} from '@/gql/fragments/OrderAttrsFields'
import {OrderFields} from '@/gql/fragments/OrderFields'
import {OrderProfileFields} from '@/gql/fragments/OrderProfileFields'
import {OrderRestrictionFields} from '@/gql/fragments/OrderRestrictionFields'
import {PageFields} from '@/gql/fragments/PageFields'
import {ProductFields} from '@/gql/fragments/ProductFields'
import {ProductFlagFields} from '@/gql/fragments/ProductFlagFields'
import {ProductIngredientFields} from '@/gql/fragments/ProductIngredientFields'
import {ProductPropsFields} from '@/gql/fragments/ProductPropsFields'
import {ProductSectionFields} from '@/gql/fragments/ProductSectionFields'
import {ProductSectionPropsFields} from '@/gql/fragments/ProductSectionPropsFields'
import {ReviewFields} from '@/gql/fragments/ReviewFields'
import {UserAuthConfirmFields} from '@/gql/fragments/UserAuthConfirmFields'
import {UserAuthConfirmStepFields} from '@/gql/fragments/UserAuthConfirmStepFields'
import {UserFields} from '@/gql/fragments/UserFields'
import {VacancyFields} from '@/gql/fragments/VacancyFields'
import {VorderCurrentFields} from '@/gql/fragments/VorderCurrentFields'
import {WebcamFields} from '@/gql/fragments/WebcamFields'
import {YandexMetrikGoalFields} from '@/gql/fragments/YandexMetrikGoalFields'
export const CommonErrorFragment = CommonError
export const RateErrorFragment = RateError
export const OtpErrorFragment = OtpError
export const AccessErrorFragment = AccessError
export const FormErrorFragment = FormError
export const ExternalServiceErrorFragment = ExternalServiceError
export const ProtocolErrorFragment = ProtocolError
export const InternalErrorFragment = InternalError
export const UserErrorFragment = UserError
export const BasketRuleBenefitDiscountFragment = BasketRuleBenefitDiscount
export const BasketRuleBenefitGiftFragment = BasketRuleBenefitGift
export const VorderErrorFragment = VorderError
export const TestItemFragment = TestItem
export const EntityOptionFragment = EntityOption
export const EntityTypeFragment = EntityType
export const EntityProviderTypeFragment = EntityProviderType
export const EntityComputedFieldFragment = EntityComputedField
export const EntityComputedFieldValueOptionFragment = EntityComputedFieldValueOption
export const MenuFragment = Menu
export const MenuItemFragment = MenuItem
export const CommandFragment = Command
export const ImageFragment = Image
export const ClientEmitFragment = ClientEmit
export const ClientNoticeFragment = ClientNotice
export const UserSessionFragment = UserSession
export const UserFragment = User
export const UserGroupFragment = UserGroup
export const EntityPropFragment = EntityProp
export const UserAvatarFragment = UserAvatar
export const UserFamilyFragment = UserFamily
export const AppClientFragment = AppClient
export const AppClientDebugParamsFragment = AppClientDebugParams
export const PageFragment = Page
export const SectionFragment = Section
export const ElementMetaFragment = ElementMeta
export const PagePropsFragment = PageProps
export const ElementPropValueWithDescFragment = ElementPropValueWithDesc
export const PagePropsChunksFragment = PagePropsChunks
export const ElementPropValueHtmlFragment = ElementPropValueHtml
export const PageDataChunkFragment = PageDataChunk
export const PageContentChunkFragment = PageContentChunk
export const PageRecordsetFragment = PageRecordset
export const QueryInfoFragment = QueryInfo
export const CompanyOfficeFragment = CompanyOffice
export const CompanyOfficePropsFragment = CompanyOfficeProps
export const CoordinatesFragment = Coordinates
export const ListValueFragment = ListValue
export const OfficeRecordsetFragment = OfficeRecordset
export const CompanyVacancyFragment = CompanyVacancy
export const CompanyVacancyPropsFragment = CompanyVacancyProps
export const VacancyRecordsetFragment = VacancyRecordset
export const FaqQuestionFragment = FaqQuestion
export const FaqQuestionRecordsetFragment = FaqQuestionRecordset
export const GeoObjectFragment = GeoObject
export const SearchSuggestionFragment = SearchSuggestion
export const SearchSuggestionDataFragment = SearchSuggestionData
export const OfferFragment = Offer
export const OfferSlideFragment = OfferSlide
export const MenuItemMobileFragment = MenuItemMobile
export const ActionMobileFragment = ActionMobile
export const ConditionFragment = Condition
export const OfferRecordsetFragment = OfferRecordset
export const PushSubscriberFragment = PushSubscriber
export const FortunePrizeFragment = FortunePrize
export const FortunePrizePropsFragment = FortunePrizeProps
export const ElementFragment = Element
export const FortuneUserPrizeFragment = FortuneUserPrize
export const TelegramChatFragment = TelegramChat
export const TelegramChatRecordsetFragment = TelegramChatRecordset
export const WebcamFragment = Webcam
export const WebcamPropsFragment = WebcamProps
export const ReviewFragment = Review
export const ReviewPropsFragment = ReviewProps
export const OrderFragment = Order
export const DeliveryServiceFragment = DeliveryService
export const PaysystemFragment = Paysystem
export const BasketItemFragment = BasketItem
export const BasketItemDiscountFragment = BasketItemDiscount
export const ProductFragment = Product
export const ProductPropsFragment = ProductProps
export const ProductPropsSetItemsFragment = ProductPropsSetItems
export const ProductPriceFragment = ProductPrice
export const ProductMeasureFragment = ProductMeasure
export const IngredientFragment = Ingredient
export const BasketBuildItemFragment = BasketBuildItem
export const BasketItemPropsFragment = BasketItemProps
export const OrderStatusFragment = OrderStatus
export const PaymentFragment = Payment
export const OrderScopeFragment = OrderScope
export const CouponFragment = Coupon
export const CourierStateFragment = CourierState
export const OrderCancelReasonFragment = OrderCancelReason
export const OrderAttributesValueFragment = OrderAttributesValue
export const OrderDataFragment = OrderData
export const OrderAttributesViewFragment = OrderAttributesView
export const OrderAttributeFragment = OrderAttribute
export const OrderAttributeOptionFragment = OrderAttributeOption
export const AppProductRecordsetFragment = AppProductRecordset
export const SearchResultFragment = SearchResult
export const VorderCurrentFragment = VorderCurrent
export const DeliveryPriceRuleFragment = DeliveryPriceRule
export const PersonTypeFragment = PersonType
export const PaymentTypeFragment = PaymentType
export const OrderProfileFragment = OrderProfile
export const OrderProfileAttributesValueFragment = OrderProfileAttributesValue
export const DiscountFragment = Discount
export const DiscountPropsFragment = DiscountProps
export const OrderConditionFragment = OrderCondition
export const DeliveryComputedFragment = DeliveryComputed
export const DeliveryWrapperFragment = DeliveryWrapper
export const TransportTypeFragment = TransportType
export const ResponseStateFragment = ResponseState
export const MessageFragment = Message
export const ResponseRateFragment = ResponseRate
export const ResponseRedirectFragment = ResponseRedirect
export const BasketRuleFragment = BasketRule
export const BasketRulePropsFragment = BasketRuleProps
export const BasketRulePropsBenefitsFragment = BasketRulePropsBenefits
export const BasketFragment = Basket
export const SpecialOfferFragment = SpecialOffer
export const SpecialOfferTypeFragment = SpecialOfferType
export const VorderSummaryFragment = VorderSummary
export const OrderProfileRecordsetFragment = OrderProfileRecordset
export const SaleClientCardFragment = SaleClientCard
export const BonusLevelFragment = BonusLevel
export const BonusLevelPropsFragment = BonusLevelProps
export const ClientCardRecordsetFragment = ClientCardRecordset
export const DeliveryZoneFragment = DeliveryZone
export const DeliveryZonePropsFragment = DeliveryZoneProps
export const ProductIngredientFragment = ProductIngredient
export const ProductIngredientPropsFragment = ProductIngredientProps
export const ModificatorFragment = Modificator
export const ModificatorSectionFragment = ModificatorSection
export const ModificatorSectionPropsFragment = ModificatorSectionProps
export const ModificatorOptionFragment = ModificatorOption
export const ModificatorPropsFragment = ModificatorProps
export const ModificatorPropsProductsFragment = ModificatorPropsProducts
export const ProductFlagFragment = ProductFlag
export const ProductFlagPropsFragment = ProductFlagProps
export const OrderRestrictionFragment = OrderRestriction
export const OrderRestrictionPropsFragment = OrderRestrictionProps
export const ProductSectionFragment = ProductSection
export const ProductSectionPropsFragment = ProductSectionProps
export const ClientSegmentFragment = ClientSegment
export const ClientSegmentRecordsetFragment = ClientSegmentRecordset
export const FeatureFragment = Feature
export const AvailableStatusFragment = AvailableStatus
export const FeaturePropsFragment = FeatureProps
export const FeatureRecordsetFragment = FeatureRecordset
export const CallTrackingPhoneFragment = CallTrackingPhone
export const CallTrackingPhonePropsFragment = CallTrackingPhoneProps
export const YandexMetricGoalFragment = YandexMetricGoal
export const YandexMetricGoalRecordsetFragment = YandexMetricGoalRecordset
export const TestmutationcreateResultFragment = TestmutationcreateResult
export const TestmutationupdateResultFragment = TestmutationupdateResult
export const ResponseFragment = Response
export const NoticePubSyncReadedResultFragment = NoticePubSyncReadedResult
export const UserAuthLoginStartResultFragment = UserAuthLoginStartResult
export const UserAuthLoginStartResultPayloadFragment = UserAuthLoginStartResultPayload
export const UserAuthConfirmFragment = UserAuthConfirm
export const UserAuthConfirmStepFragment = UserAuthConfirmStep
export const UserAuthLoginRequestResultFragment = UserAuthLoginRequestResult
export const UserAuthLoginRequestResultPayloadFragment = UserAuthLoginRequestResultPayload
export const UserAuthLoginConfirmResultFragment = UserAuthLoginConfirmResult
export const UserAuthLoginConfirmResultPayloadFragment = UserAuthLoginConfirmResultPayload
export const UserProfileNameResultFragment = UserProfileNameResult
export const UserProfileBirthdayResultFragment = UserProfileBirthdayResult
export const UserProfileEmailResultFragment = UserProfileEmailResult
export const CompanyOfficeUpdateResultFragment = CompanyOfficeUpdateResult
export const PushSubscribeResultFragment = PushSubscribeResult
export const PushSubscribeResultPayloadFragment = PushSubscribeResultPayload
export const PushUnsubscribeResultFragment = PushUnsubscribeResult
export const PushUnsubscribeResultPayloadFragment = PushUnsubscribeResultPayload
export const PushSendTestResultFragment = PushSendTestResult
export const PushSendTestResultPayloadFragment = PushSendTestResultPayload
export const FortuneSpinResultFragment = FortuneSpinResult
export const FortuneSpinResultPayloadFragment = FortuneSpinResultPayload
export const TelegramCreateResultFragment = TelegramCreateResult
export const TelegramUpdateResultFragment = TelegramUpdateResult
export const TelegramAuthByPhoneResultFragment = TelegramAuthByPhoneResult
export const TelegramAuthByPhoneResultPayloadFragment = TelegramAuthByPhoneResultPayload
export const ReviewServiceReviewResultFragment = ReviewServiceReviewResult
export const ReviewOrderGuestReviewResultFragment = ReviewOrderGuestReviewResult
export const ReviewOrderGuestReviewResultPayloadFragment = ReviewOrderGuestReviewResultPayload
export const SaleOrderTestResultFragment = SaleOrderTestResult
export const SaleOrderTestResultPayloadFragment = SaleOrderTestResultPayload
export const SaleOrderPayOnlineResultFragment = SaleOrderPayOnlineResult
export const SaleOrderPayOnlineResultPayloadFragment = SaleOrderPayOnlineResultPayload
export const SaleOrderRepeatResultFragment = SaleOrderRepeatResult
export const SaleOrderCancelResultFragment = SaleOrderCancelResult
export const VorderNewResultFragment = VorderNewResult
export const VorderNewResultPayloadFragment = VorderNewResultPayload
export const VorderFragment = Vorder
export const VorderApplyResultFragment = VorderApplyResult
export const VorderApplyResultPayloadFragment = VorderApplyResultPayload
export const VorderBasketResultFragment = VorderBasketResult
export const VorderBasketResultPayloadFragment = VorderBasketResultPayload
export const VorderDeliveryCalculateResultFragment = VorderDeliveryCalculateResult
export const VorderDeliveryCalculateResultPayloadFragment = VorderDeliveryCalculateResultPayload
export const DeliveryCalculateFragment = DeliveryCalculate
export const VorderCouponResultFragment = VorderCouponResult
export const VorderCouponResultPayloadFragment = VorderCouponResultPayload
export const VorderSubmitResultFragment = VorderSubmitResult
export const VorderSubmitResultPayloadFragment = VorderSubmitResultPayload
export const VorderSyncResultFragment = VorderSyncResult
export const VorderSyncResultPayloadFragment = VorderSyncResultPayload
export const SaleProfileDefaultResultFragment = SaleProfileDefaultResult
export const SaleProfileDeleteResultFragment = SaleProfileDeleteResult
export const SaleProfileSaveResultFragment = SaleProfileSaveResult
export const SaleProfileCalcDeliveryResultFragment = SaleProfileCalcDeliveryResult
export const SaleClientCardCreateResultFragment = SaleClientCardCreateResult
export const SaleClientCardUpdateResultFragment = SaleClientCardUpdateResult
export const CallTrackingRequestPhoneResultFragment = CallTrackingRequestPhoneResult
export const CallTrackingRequestPhoneResultPayloadFragment = CallTrackingRequestPhoneResultPayload
export const BasketItemFieldsFragment = BasketItemFields
export const BasketRuleConditionFieldsFragment = BasketRuleConditionFields
export const BasketRuleFieldsFragment = BasketRuleFields
export const BonusLevelFieldsFragment = BonusLevelFields
export const CallTrackingPhoneFieldsFragment = CallTrackingPhoneFields
export const ClientCardFieldsFragment = ClientCardFields
export const CouponFieldsFragment = CouponFields
export const DeliveryCalculateFieldsFragment = DeliveryCalculateFields
export const DeliveryZoneFieldsFragment = DeliveryZoneFields
export const DiscountFieldsFragment = DiscountFields
export const ErrorFieldsFragment = ErrorFields
export const FaqQuestionFieldsFragment = FaqQuestionFields
export const FeatureFieldsFragment = FeatureFields
export const FortunePrizeFieldsFragment = FortunePrizeFields
export const FortuneUserPrizeFieldsFragment = FortuneUserPrizeFields
export const MenuFieldsFragment = MenuFields
export const MenuItemBaseFieldsFragment = MenuItemBaseFields
export const MenuItemFieldsFragment = MenuItemFields
export const ModificatorFieldsFragment = ModificatorFields
export const NoticeFieldsFragment = NoticeFields
export const OfferFieldsFragment = OfferFields
export const OfficeFieldsFragment = OfficeFields
export const OrderAttrsFieldsFragment = OrderAttrsFields
export const OrderFieldsFragment = OrderFields
export const OrderProfileFieldsFragment = OrderProfileFields
export const OrderRestrictionFieldsFragment = OrderRestrictionFields
export const PageFieldsFragment = PageFields
export const ProductFieldsFragment = ProductFields
export const ProductFlagFieldsFragment = ProductFlagFields
export const ProductIngredientFieldsFragment = ProductIngredientFields
export const ProductPropsFieldsFragment = ProductPropsFields
export const ProductSectionFieldsFragment = ProductSectionFields
export const ProductSectionPropsFieldsFragment = ProductSectionPropsFields
export const ReviewFieldsFragment = ReviewFields
export const UserAuthConfirmFieldsFragment = UserAuthConfirmFields
export const UserAuthConfirmStepFieldsFragment = UserAuthConfirmStepFields
export const UserFieldsFragment = UserFields
export const VacancyFieldsFragment = VacancyFields
export const VorderCurrentFieldsFragment = VorderCurrentFields
export const WebcamFieldsFragment = WebcamFields
export const YandexMetrikGoalFieldsFragment = YandexMetrikGoalFields
export const fragments = {
    CommonError,
    RateError,
    OtpError,
    AccessError,
    FormError,
    ExternalServiceError,
    ProtocolError,
    InternalError,
    UserError,
    BasketRuleBenefitDiscount,
    BasketRuleBenefitGift,
    VorderError,
    TestItem,
    EntityOption,
    EntityType,
    EntityProviderType,
    EntityComputedField,
    EntityComputedFieldValueOption,
    Menu,
    MenuItem,
    Command,
    Image,
    ClientEmit,
    ClientNotice,
    UserSession,
    User,
    UserGroup,
    EntityProp,
    UserAvatar,
    UserFamily,
    AppClient,
    AppClientDebugParams,
    Page,
    Section,
    ElementMeta,
    PageProps,
    ElementPropValueWithDesc,
    PagePropsChunks,
    ElementPropValueHtml,
    PageDataChunk,
    PageContentChunk,
    PageRecordset,
    QueryInfo,
    CompanyOffice,
    CompanyOfficeProps,
    Coordinates,
    ListValue,
    OfficeRecordset,
    CompanyVacancy,
    CompanyVacancyProps,
    VacancyRecordset,
    FaqQuestion,
    FaqQuestionRecordset,
    GeoObject,
    SearchSuggestion,
    SearchSuggestionData,
    Offer,
    OfferSlide,
    MenuItemMobile,
    ActionMobile,
    Condition,
    OfferRecordset,
    PushSubscriber,
    FortunePrize,
    FortunePrizeProps,
    Element,
    FortuneUserPrize,
    TelegramChat,
    TelegramChatRecordset,
    Webcam,
    WebcamProps,
    Review,
    ReviewProps,
    Order,
    DeliveryService,
    Paysystem,
    BasketItem,
    BasketItemDiscount,
    Product,
    ProductProps,
    ProductPropsSetItems,
    ProductPrice,
    ProductMeasure,
    Ingredient,
    BasketBuildItem,
    BasketItemProps,
    OrderStatus,
    Payment,
    OrderScope,
    Coupon,
    CourierState,
    OrderCancelReason,
    OrderAttributesValue,
    OrderData,
    OrderAttributesView,
    OrderAttribute,
    OrderAttributeOption,
    AppProductRecordset,
    SearchResult,
    VorderCurrent,
    DeliveryPriceRule,
    PersonType,
    PaymentType,
    OrderProfile,
    OrderProfileAttributesValue,
    Discount,
    DiscountProps,
    OrderCondition,
    DeliveryComputed,
    DeliveryWrapper,
    TransportType,
    ResponseState,
    Message,
    ResponseRate,
    ResponseRedirect,
    BasketRule,
    BasketRuleProps,
    BasketRulePropsBenefits,
    Basket,
    SpecialOffer,
    SpecialOfferType,
    VorderSummary,
    OrderProfileRecordset,
    SaleClientCard,
    BonusLevel,
    BonusLevelProps,
    ClientCardRecordset,
    DeliveryZone,
    DeliveryZoneProps,
    ProductIngredient,
    ProductIngredientProps,
    Modificator,
    ModificatorSection,
    ModificatorSectionProps,
    ModificatorOption,
    ModificatorProps,
    ModificatorPropsProducts,
    ProductFlag,
    ProductFlagProps,
    OrderRestriction,
    OrderRestrictionProps,
    ProductSection,
    ProductSectionProps,
    ClientSegment,
    ClientSegmentRecordset,
    Feature,
    AvailableStatus,
    FeatureProps,
    FeatureRecordset,
    CallTrackingPhone,
    CallTrackingPhoneProps,
    YandexMetricGoal,
    YandexMetricGoalRecordset,
    TestmutationcreateResult,
    TestmutationupdateResult,
    Response,
    NoticePubSyncReadedResult,
    UserAuthLoginStartResult,
    UserAuthLoginStartResultPayload,
    UserAuthConfirm,
    UserAuthConfirmStep,
    UserAuthLoginRequestResult,
    UserAuthLoginRequestResultPayload,
    UserAuthLoginConfirmResult,
    UserAuthLoginConfirmResultPayload,
    UserProfileNameResult,
    UserProfileBirthdayResult,
    UserProfileEmailResult,
    CompanyOfficeUpdateResult,
    PushSubscribeResult,
    PushSubscribeResultPayload,
    PushUnsubscribeResult,
    PushUnsubscribeResultPayload,
    PushSendTestResult,
    PushSendTestResultPayload,
    FortuneSpinResult,
    FortuneSpinResultPayload,
    TelegramCreateResult,
    TelegramUpdateResult,
    TelegramAuthByPhoneResult,
    TelegramAuthByPhoneResultPayload,
    ReviewServiceReviewResult,
    ReviewOrderGuestReviewResult,
    ReviewOrderGuestReviewResultPayload,
    SaleOrderTestResult,
    SaleOrderTestResultPayload,
    SaleOrderPayOnlineResult,
    SaleOrderPayOnlineResultPayload,
    SaleOrderRepeatResult,
    SaleOrderCancelResult,
    VorderNewResult,
    VorderNewResultPayload,
    Vorder,
    VorderApplyResult,
    VorderApplyResultPayload,
    VorderBasketResult,
    VorderBasketResultPayload,
    VorderDeliveryCalculateResult,
    VorderDeliveryCalculateResultPayload,
    DeliveryCalculate,
    VorderCouponResult,
    VorderCouponResultPayload,
    VorderSubmitResult,
    VorderSubmitResultPayload,
    VorderSyncResult,
    VorderSyncResultPayload,
    SaleProfileDefaultResult,
    SaleProfileDeleteResult,
    SaleProfileSaveResult,
    SaleProfileCalcDeliveryResult,
    SaleClientCardCreateResult,
    SaleClientCardUpdateResult,
    CallTrackingRequestPhoneResult,
    CallTrackingRequestPhoneResultPayload,
    BasketItemFields,
    BasketRuleConditionFields,
    BasketRuleFields,
    BonusLevelFields,
    CallTrackingPhoneFields,
    ClientCardFields,
    CouponFields,
    DeliveryCalculateFields,
    DeliveryZoneFields,
    DiscountFields,
    ErrorFields,
    FaqQuestionFields,
    FeatureFields,
    FortunePrizeFields,
    FortuneUserPrizeFields,
    MenuFields,
    MenuItemBaseFields,
    MenuItemFields,
    ModificatorFields,
    NoticeFields,
    OfferFields,
    OfficeFields,
    OrderAttrsFields,
    OrderFields,
    OrderProfileFields,
    OrderRestrictionFields,
    PageFields,
    ProductFields,
    ProductFlagFields,
    ProductIngredientFields,
    ProductPropsFields,
    ProductSectionFields,
    ProductSectionPropsFields,
    ReviewFields,
    UserAuthConfirmFields,
    UserAuthConfirmStepFields,
    UserFields,
    VacancyFields,
    VorderCurrentFields,
    WebcamFields,
    YandexMetrikGoalFields
}
export type JsonFragmentName = 'CommonError' | 'RateError' | 'OtpError' | 'AccessError' | 'FormError' | 'ExternalServiceError' | 'ProtocolError' | 'InternalError' | 'UserError' | 'BasketRuleBenefitDiscount' | 'BasketRuleBenefitGift' | 'VorderError' | 'TestItem' | 'EntityOption' | 'EntityType' | 'EntityProviderType' | 'EntityComputedField' | 'EntityComputedFieldValueOption' | 'Menu' | 'MenuItem' | 'Command' | 'Image' | 'ClientEmit' | 'ClientNotice' | 'UserSession' | 'User' | 'UserGroup' | 'EntityProp' | 'UserAvatar' | 'UserFamily' | 'AppClient' | 'AppClientDebugParams' | 'Page' | 'Section' | 'ElementMeta' | 'PageProps' | 'ElementPropValueWithDesc' | 'PagePropsChunks' | 'ElementPropValueHtml' | 'PageDataChunk' | 'PageContentChunk' | 'PageRecordset' | 'QueryInfo' | 'CompanyOffice' | 'CompanyOfficeProps' | 'Coordinates' | 'ListValue' | 'OfficeRecordset' | 'CompanyVacancy' | 'CompanyVacancyProps' | 'VacancyRecordset' | 'FaqQuestion' | 'FaqQuestionRecordset' | 'GeoObject' | 'SearchSuggestion' | 'SearchSuggestionData' | 'Offer' | 'OfferSlide' | 'MenuItemMobile' | 'ActionMobile' | 'Condition' | 'OfferRecordset' | 'PushSubscriber' | 'FortunePrize' | 'FortunePrizeProps' | 'Element' | 'FortuneUserPrize' | 'TelegramChat' | 'TelegramChatRecordset' | 'Webcam' | 'WebcamProps' | 'Review' | 'ReviewProps' | 'Order' | 'DeliveryService' | 'Paysystem' | 'BasketItem' | 'BasketItemDiscount' | 'Product' | 'ProductProps' | 'ProductPropsSetItems' | 'ProductPrice' | 'ProductMeasure' | 'Ingredient' | 'BasketBuildItem' | 'BasketItemProps' | 'OrderStatus' | 'Payment' | 'OrderScope' | 'Coupon' | 'CourierState' | 'OrderCancelReason' | 'OrderAttributesValue' | 'OrderData' | 'OrderAttributesView' | 'OrderAttribute' | 'OrderAttributeOption' | 'AppProductRecordset' | 'SearchResult' | 'VorderCurrent' | 'DeliveryPriceRule' | 'PersonType' | 'PaymentType' | 'OrderProfile' | 'OrderProfileAttributesValue' | 'Discount' | 'DiscountProps' | 'OrderCondition' | 'DeliveryComputed' | 'DeliveryWrapper' | 'TransportType' | 'ResponseState' | 'Message' | 'ResponseRate' | 'ResponseRedirect' | 'BasketRule' | 'BasketRuleProps' | 'BasketRulePropsBenefits' | 'Basket' | 'SpecialOffer' | 'SpecialOfferType' | 'VorderSummary' | 'OrderProfileRecordset' | 'SaleClientCard' | 'BonusLevel' | 'BonusLevelProps' | 'ClientCardRecordset' | 'DeliveryZone' | 'DeliveryZoneProps' | 'ProductIngredient' | 'ProductIngredientProps' | 'Modificator' | 'ModificatorSection' | 'ModificatorSectionProps' | 'ModificatorOption' | 'ModificatorProps' | 'ModificatorPropsProducts' | 'ProductFlag' | 'ProductFlagProps' | 'OrderRestriction' | 'OrderRestrictionProps' | 'ProductSection' | 'ProductSectionProps' | 'ClientSegment' | 'ClientSegmentRecordset' | 'Feature' | 'AvailableStatus' | 'FeatureProps' | 'FeatureRecordset' | 'CallTrackingPhone' | 'CallTrackingPhoneProps' | 'YandexMetricGoal' | 'YandexMetricGoalRecordset' | 'TestmutationcreateResult' | 'TestmutationupdateResult' | 'Response' | 'NoticePubSyncReadedResult' | 'UserAuthLoginStartResult' | 'UserAuthLoginStartResultPayload' | 'UserAuthConfirm' | 'UserAuthConfirmStep' | 'UserAuthLoginRequestResult' | 'UserAuthLoginRequestResultPayload' | 'UserAuthLoginConfirmResult' | 'UserAuthLoginConfirmResultPayload' | 'UserProfileNameResult' | 'UserProfileBirthdayResult' | 'UserProfileEmailResult' | 'CompanyOfficeUpdateResult' | 'PushSubscribeResult' | 'PushSubscribeResultPayload' | 'PushUnsubscribeResult' | 'PushUnsubscribeResultPayload' | 'PushSendTestResult' | 'PushSendTestResultPayload' | 'FortuneSpinResult' | 'FortuneSpinResultPayload' | 'TelegramCreateResult' | 'TelegramUpdateResult' | 'TelegramAuthByPhoneResult' | 'TelegramAuthByPhoneResultPayload' | 'ReviewServiceReviewResult' | 'ReviewOrderGuestReviewResult' | 'ReviewOrderGuestReviewResultPayload' | 'SaleOrderTestResult' | 'SaleOrderTestResultPayload' | 'SaleOrderPayOnlineResult' | 'SaleOrderPayOnlineResultPayload' | 'SaleOrderRepeatResult' | 'SaleOrderCancelResult' | 'VorderNewResult' | 'VorderNewResultPayload' | 'Vorder' | 'VorderApplyResult' | 'VorderApplyResultPayload' | 'VorderBasketResult' | 'VorderBasketResultPayload' | 'VorderDeliveryCalculateResult' | 'VorderDeliveryCalculateResultPayload' | 'DeliveryCalculate' | 'VorderCouponResult' | 'VorderCouponResultPayload' | 'VorderSubmitResult' | 'VorderSubmitResultPayload' | 'VorderSyncResult' | 'VorderSyncResultPayload' | 'SaleProfileDefaultResult' | 'SaleProfileDeleteResult' | 'SaleProfileSaveResult' | 'SaleProfileCalcDeliveryResult' | 'SaleClientCardCreateResult' | 'SaleClientCardUpdateResult' | 'CallTrackingRequestPhoneResult' | 'CallTrackingRequestPhoneResultPayload' | 'BasketItemFields' | 'BasketRuleConditionFields' | 'BasketRuleFields' | 'BonusLevelFields' | 'CallTrackingPhoneFields' | 'ClientCardFields' | 'CouponFields' | 'DeliveryCalculateFields' | 'DeliveryZoneFields' | 'DiscountFields' | 'ErrorFields' | 'FaqQuestionFields' | 'FeatureFields' | 'FortunePrizeFields' | 'FortuneUserPrizeFields' | 'MenuFields' | 'MenuItemBaseFields' | 'MenuItemFields' | 'ModificatorFields' | 'NoticeFields' | 'OfferFields' | 'OfficeFields' | 'OrderAttrsFields' | 'OrderFields' | 'OrderProfileFields' | 'OrderRestrictionFields' | 'PageFields' | 'ProductFields' | 'ProductFlagFields' | 'ProductIngredientFields' | 'ProductPropsFields' | 'ProductSectionFields' | 'ProductSectionPropsFields' | 'ReviewFields' | 'UserAuthConfirmFields' | 'UserAuthConfirmStepFields' | 'UserFields' | 'VacancyFields' | 'VorderCurrentFields' | 'WebcamFields' | 'YandexMetrikGoalFields'